'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventSecurityRoutes = [
  {
    path: 'securities',
    component: EmptyRouterView,
    children: [

    ],
  },
];

export const eventManageSecurityRoutes = [
  {
    path: 'securities',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.security.list',
        props: true,
        component: () => import('../views/ManageSecurityListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.security.add',
        props: true,
        component: () => import('../views/ManageSecurityAddView.vue'),
      },
    ],
  },
];
